import { ChakraFlex } from '@equip.health/ui';
import { useParams } from 'react-router-dom';

import { useGetPatientQuery } from '~/store/services/patients';
import Smt from '~/components/maud/patients/profile/smt';
import { useGetSMTPermissionsQuery } from '~/store/services/SMT';

const JournalPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patient } = useGetPatientQuery({ patientId });
  const { data: smtPermissions } = useGetSMTPermissionsQuery(
    patient?.userId ?? '',
    { skip: !patient?.userId },
  );
  const isSMTEnabledForPatient = smtPermissions?.smtEnabled ?? false;

  if (!patient) return null;

  return (
    <ChakraFlex
      flexDirection="column"
      gap="24px"
      marginBottom="24px"
      marginTop="12px"
    >
      <Smt
        isSMTEnabledForPatient={isSMTEnabledForPatient}
        patientId={patient.userId}
      />
    </ChakraFlex>
  );
};

export default JournalPage;
